import type {PropsOf} from '@chakra-ui/react';
import {Skeleton} from '@chakra-ui/react';
import type {ChakraDiv} from '@linx-security/ui/utils/chakra-elements';
import type {PropsWithChildren} from 'react';
import {Children, cloneElement, forwardRef} from 'react';

import type {WidgetContext} from './Container';
import {useStyles} from './context';

type Props = PropsWithChildren<PropsOf<typeof ChakraDiv>> & WidgetContext;
export const WidgetSkeleton = forwardRef(
  (
    {isInteractive: _isInteractive, isEmpty: _isEmpty, isLoading: _isLoading, hasError: _hasError, ...props}: Props,
    ref,
  ) => {
    const {skeleton: __css} = useStyles();
    const {children} = props;

    /**
     * Ensure that the skeleton has only one child
     */
    const child = Children.only(children ?? <></>) as React.ReactElement<any> & {
      ref?: React.Ref<any>;
    };

    return children ? (
      cloneElement(child, {ref, ...props})
    ) : (
      <Skeleton isLoaded={false} sx={__css} alignSelf={`stretch`} ref={ref} {...props} />
    );
  },
);
